import React, { useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'
import { ImperativePanelHandle, Panel, PanelGroup, PanelResizeHandle } from 'react-resizable-panels'
import { createLeftNavigationMinimisedSelector } from 'selectors/selectionSelectors'

interface SplitPanelProps {
  children: [JSX.Element, JSX.Element]
}

const DEFAULT_SIZE = 9.5
const MIN_SIZE = 2.5

export const SplitPanel: React.FC<SplitPanelProps> = ({ children }) => {
  const isLeftNavigationMinimised = useSelector(createLeftNavigationMinimisedSelector())
  const [leftSidePanel, rightSidePanel] = children
  const previousSize = useRef<number>()
  const ref = useRef<ImperativePanelHandle>(null)

  useEffect(() => {
    if (isLeftNavigationMinimised) {
      previousSize.current = ref.current?.getSize()
      ref.current?.resize(MIN_SIZE)
    } else {
      ref.current?.resize(previousSize.current ?? DEFAULT_SIZE)
    }
  }, [isLeftNavigationMinimised])

  return (
    <PanelGroup direction="horizontal">
      <Panel defaultSize={9.5} minSize={2.5} ref={ref}>
        {leftSidePanel}
      </Panel>
      <PanelResizeHandle className="ResizeHandle" />
      <Panel className="MainScreen">{rightSidePanel}</Panel>
    </PanelGroup>
  )
}
